import {
  PRICELIST_DETAIL_TABS,
} from '@/features/pricelist/components/PricelistDetail'
import { PricelistDetailPage } from '@/features/pricelist/pages/PricelistDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/admin/pricelist/$id/detail')({
  validateSearch: z.object({
    // Optional so every existing link to this page keeps working untouched.
    tab: z.enum(PRICELIST_DETAIL_TABS).optional().catch(undefined),
  }),
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistDetailPage,
})
